import { useSelector } from "react-redux";
import { Badge, Group, Tooltip} from '@mantine/core';
import intl from "react-intl-universal";


export function IdentCount() {
  const meetinguser = useSelector((state: any) => state.user.meetinguser)



  const inmeetinguserdata = meetinguser.filter((obj: { role: any; isToBeIdentified: boolean;  }) => {
    return obj.role !== "notar" && obj.isToBeIdentified === true && obj.role !== "gast"
    });

  const toidentuserarray:any = Object.values(inmeetinguserdata);

  let countalreadysign = 0
  // eslint-disable-next-line array-callback-return
  inmeetinguserdata.map((item:any) => {
    if (item.actions[0].isDone){
      countalreadysign = countalreadysign + 1
     }  
  });

  return (
    <>
    <Group>
    <Tooltip label={intl.get('IDENTCOUNT_USER')} multiline={true}>
        <Badge color="gray" variant="outline">{toidentuserarray.length}</Badge>
    </Tooltip>
    <Tooltip label={intl.get('IDENTCOUNT_USER_DONE')} multiline={true}>
        <Badge color="green" variant="outline">{countalreadysign}</Badge>
      </Tooltip>
   </Group>
    </>
  );
}